import EnumItem from '../../../common/utils/Enum'
import { i18n } from '../../../common/utils/i18n'

export default new EnumItem({
  WINE_BEER: {
    text: i18n.gettext('啤酒'),
    value: 107
  },
  WINE_BRANDY: {
    text: i18n.gettext('白兰地'),
    value: 102
  },
  WINE_CODKA: {
    text: i18n.gettext('伏特加'),
    value: 103
  },
  WINE_GENEVA: {
    text: i18n.gettext('金酒'),
    value: 106
  },
  WINE_RED: {
    text: i18n.gettext('葡萄酒'),
    value: 108
  },
  WINE_MEZCAL: {
    text: i18n.gettext('梅斯卡尔酒'),
    value: 109
  },
  WINE_RUM: {
    text: i18n.gettext('朗姆酒'),
    value: 104
  },
  WINE_TEQUILA: {
    text: i18n.gettext('龙舌兰酒'),
    value: 105
  },
  WINE_WHISKY: {
    text: i18n.gettext('威士忌'),
    value: 101
  }
})
